import { useEffect, useRef, useState } from "react"

import {
  AGENT_AI_DISCOVERY_DRAWER_ID,
  APPLICATION_DRAWER_ID,
  CODE_REPOSITORY_DRAWER_ID,
  IMAGE_DRAWER_ID,
  TRIAGE_DRAWER_ID,
  VIRTUAL_MACHINE_DRAWER_ID
} from "@/organisms/Drawers/const"

export type DrawerId =
  | typeof APPLICATION_DRAWER_ID
  | typeof IMAGE_DRAWER_ID
  | typeof CODE_REPOSITORY_DRAWER_ID
  | typeof TRIAGE_DRAWER_ID
  | typeof VIRTUAL_MACHINE_DRAWER_ID
  | typeof AGENT_AI_DISCOVERY_DRAWER_ID

export type RowClick = (attr: { key: string }, drawerId: DrawerId) => void

export type ActionOpenDrawer = (drawerId: DrawerId, key: string) => void

export const useLinkDrawerTooltip = (props?: { onRowClick?: RowClick }) => {
  const { onRowClick } = props || {}
  const [open, setOpen] = useState<false | undefined>(undefined)
  const timerRef = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => () => clearTimeout(timerRef.current), [])

  const openDrawer = (drawerId?: DrawerId, recordId?: string) => {
    setOpen(false)
    clearTimeout(timerRef.current)

    timerRef.current = setTimeout(() => {
      setOpen(undefined)

      if (!drawerId || !recordId) return

      onRowClick?.({ key: recordId }, drawerId)
    }, 100)
  }

  return { open, openDrawer }
}
